/* ARCHER LASER — the catalogue is Shopify. Products are read live from the
   store on every page load (see templates/index.liquid). Nothing is listed here. */
window.__SHOPIFY__ = { store: "archerlaser.myshopify.com" };
window.__SHOP__ = [];
